import { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";

export function Combobox({ options, value, onChange, placeholder, searchPlaceholder, empty = "No matches", disabled, testId }) {
  const [open, setOpen] = useState(false);
  const current = options.find((o) => o.value === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" disabled={disabled} data-testid={testId} role="combobox" aria-expanded={open}
          className="flex h-12 w-full items-center justify-between rounded-xl border border-[#E6DBCF] bg-white/80 px-4 text-left text-base text-[#2C1810] transition-colors hover:border-[#D99B90] focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#C5A059] disabled:cursor-not-allowed disabled:opacity-50 sm:text-sm">
          <span className={`truncate ${current ? "" : "text-[#A88B7D]"}`}>{current ? current.label : placeholder}</span>
          <ChevronsUpDown size={16} className="shrink-0 text-[#A88B7D]" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[var(--radix-popover-trigger-width)] p-0" align="start">
        <Command>
          <CommandInput placeholder={searchPlaceholder} data-testid={`${testId}-search`} />
          <CommandList>
            <CommandEmpty>{empty}</CommandEmpty>
            <CommandGroup>
              {options.map((o) => (
                <CommandItem key={o.value} value={`${o.label} ${o.value}`} data-testid={`${testId}-option`}
                  onSelect={() => { onChange(o.value); setOpen(false); }} className="py-2.5">
                  <Check size={14} className={`mr-2 ${o.value === value ? "opacity-100" : "opacity-0"}`} />
                  <span className="flex-1 truncate">{o.label}</span>
                  {o.sub && <span className="ml-2 text-[11px] text-[#A88B7D]">{o.sub}</span>}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
